import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    checkDeleteUrl: String,
    documentId: Number,
    containerId: Number,
    documentFilename: String,
  };

  connect() {
    console.log("Deletion controller connected");
  }

  async showDeleteModal(event) {
    event.preventDefault();

    const modal = document.getElementById("deleteModal");
    document.getElementById("deleteFileName").textContent =
      this.documentFilenameValue;

    try {
      const response = await fetch(this.checkDeleteUrlValue, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      });

      if (!response.ok) throw new Error("Failed to check deletion options");

      const data = await response.json();

      // Update modal content
      const contextEl = document.getElementById("deleteContainerContext");
      const deleteFromAllBtn = document.getElementById("deleteFromAllBtn");

      if (data.container_count > 1) {
        contextEl.textContent = `This document is available in ${data.container_count} containers. You can delete it only from this container or remove it from all containers.`;
        deleteFromAllBtn.classList.remove("hidden");
      } else {
        contextEl.textContent =
          "This document only exists in this container. Deleting it will remove it completely.";
        deleteFromAllBtn.classList.add("hidden");
      }

      // Show modal
      modal.classList.remove("hidden");

      // Attach event listeners
      document.getElementById("deleteCancelBtn").onclick = () =>
        this.cancelDelete();
      document.getElementById("deleteOnlyHereBtn").onclick = (e) =>
        this.deleteOnlyHere(e);
      document.getElementById("deleteFromAllBtn").onclick = (e) =>
        this.deleteFromAll(e);
    } catch (error) {
      console.error("Error:", error);
      alert("Error loading deletion options");
    }
  }

  cancelDelete() {
    document.getElementById("deleteModal").classList.add("hidden");
  }

  async deleteOnlyHere(event) {
    event.preventDefault();
    await this.performDelete("container");
  }

  async deleteFromAll(event) {
    event.preventDefault();
    await this.performDelete("all");
  }

  async performDelete(deleteType) {
    const modal = document.getElementById("deleteModal");
    const loader = document.getElementById("deleteLoadingOverlay");

    loader.classList.remove("hidden");

    try {
      const url = `/documents/${this.documentIdValue}`;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          delete_type: deleteType,
          container_id: this.containerIdValue,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Deletion failed");
      }

      const data = await response.json();
      modal.classList.add("hidden");

      // Redirect to the provided location
      if (data.redirect_to) {
        window.location.href = data.redirect_to;
      }
    } catch (error) {
      console.error("Error:", error);
      alert(`Error: ${error.message}`);
      loader.classList.add("hidden");
    }
  }
}
